import { createRoot } from 'react-dom/client';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { setup as setupMonitor } from './common/services/monitor';
import './i18n';
import './index.scss';
import 'react-quill/dist/quill.snow.css';
import { setupTrackings } from './common/services/tracking';

const container = document.getElementById('root');
const root = createRoot(container!); // createRoot(container!) if you use TypeScript
root.render(<App />);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
// Setup Datadog Monitor
setupMonitor();
setupTrackings();
